import { vars } from "@common/styles/abstracts/vars";
import { Flex as BaseFlex } from "@common/styles/reusable/Flex/Flex.styles";
import styled, { css } from "styled-components";

import Heading from "../../Heading/Heading";
import Paragraph from "../../Paragraph/Paragraph";

export const Title = styled(Heading)`
  color: ${vars.colors.grey30};
  word-break: break-word;
`;

export const Subtitle = styled(Paragraph)`
  word-break: break-word;
`;

export const Logo = styled.img`
  width: 2.4rem;
`;

export const Info = styled.button`
  width: 2.4rem;
  height: 2.4rem;
  background: none;
  border: none;
  outline: none;

  path {
    color: ${vars.colors.grey70};
  }
`;

export const Flex = styled(BaseFlex)<{ $hasSeparator?: boolean; $noContent?: boolean }>`
  padding-bottom: 2.4rem;

  ${(props) =>
    props.$hasSeparator &&
    css`
      border-bottom: 1px solid ${vars.colors.grey90};
      margin-bottom: 2.4rem;
    `};

  ${(props) =>
    props.$noContent &&
    css`
      border-bottom: none;
      margin-bottom: 0;
      padding-bottom: 0;
    `};
`;
